import React from 'react'
import { CrownIcon, LayersIcon, HeadingIcon, CirclePlayIcon } from 'images'
import { useTranslation } from 'react-i18next'


const MediaLabel = ({ variant, variantsCount = 0, headline, onVariantClick, position = 'top-left', bothSelected = false }) => {
  const { t } = useTranslation()

  if (variant === 'original') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label">
          <CrownIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.original')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'original-variants') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label">
          <CrownIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.original')}</span>
        </p>

        {variantsCount > 0 && 
          <p
            className={`label navy${onVariantClick ? ' clickable' : ''}`}
            onClick={onVariantClick ? 
              (event) => {
                event.stopPropagation()
                onVariantClick()
              }
              : undefined}
          >
            <LayersIcon width={12} height={12} />
            <span className="text">{variantsCount}</span>
          </p>
        }
      </div>
    )
  }

  if (variant === 'variant-headline') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label navy">
          <LayersIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.variantsCount', { count: variantsCount })}</span>
        </p>

        {headline && (
          <p className="label navy">
            <HeadingIcon width={12} height={12} className='heading-icon' />
            <span className="text">{headline}</span>
          </p>
        )}
      </div>
    )
  }

  if (variant === 'variant') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label navy">
          <LayersIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.variant')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'uploaded') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label">
          <CrownIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.uploaded')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'uploaded-variants') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label">
          <CrownIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.uploaded')}</span>
        </p>

        {variantsCount > 0 && 
          <p
            className={`label olive${onVariantClick ? ' clickable' : ''}`}
            onClick={onVariantClick ? 
              (event) => {
                event.stopPropagation()
                onVariantClick()
              }
              : undefined}
          >
            <LayersIcon width={12} height={12} />
            <span className="text">{variantsCount}</span>
          </p>
        }
      </div>
    )
  }

  if (variant === 'generated') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        {headline && (
          <p className="label olive">
            <HeadingIcon width={12} height={12} className='heading-icon' />
            <span className="text">{headline}</span>
          </p>
        )}

        <p className="label olive">
          <LayersIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.generated')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'video') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        {bothSelected && (
          <p className="label navy">
            <span className="text">{t('Recommendations.campaign.setup.media.label.metaOnly')}</span>
          </p>
        )}

        <p className="label" style={{ maxWidth: '140px' }}>
          <CirclePlayIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.videoUploaded')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'youtube') {
    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        {bothSelected && (
          <p className="label navy">
            <span className="text">{t('Recommendations.campaign.setup.media.label.googleOnly')}</span>
          </p>
        )}

        <p className="label red" style={{ maxWidth: '140px' }}>
          <CirclePlayIcon width={12} height={12} />
          <span className="text">{t('Recommendations.campaign.setup.media.label.youtubeVideo')}</span>
        </p>
      </div>
    )
  }

  if (variant === 'meta') {
    if (!bothSelected) {
      return null
    }

    return (
      <div className={`media-list-item__preview-label-container ${position}`}>
        <p className="label navy">
          <span className="text">{t('Recommendations.campaign.setup.media.label.metaOnly')}</span>
        </p>
      </div>
    )
  }


  return null
}

export default MediaLabel
